export default __webpack_public_path__ + "static/media/SavedBills.c43ffcc2.svg";